module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/conversation1-b0125aef58d27f2caa47dc40f3ea6ae6.jpg";